window.$ = window.jQuery = require('jquery');
require('bootstrap/js/src');

// Workaround for mdb's AMD loader, https://git.io/vbOWE
window.Waves = require('node-waves');
require('mdbootstrap/js/mdb');
delete window.Waves;


var Vue = require('vue');
var VeeValidate = require('vee-validate');

var VueI18n = require('vue-i18n');
var Toasted = require('vue-toasted').default;

Vue.use(Toasted);
Vue.use(VueI18n);

// configs
Vue.config.common = require('./cfg/common');
Vue.config.appcfg = require('./cfg/app_config');
Vue.config.lang = Vue.config.appcfg.lang;
Vue.config.backend = Vue.config.appcfg.backend;

// set locales
var locales = require('./lang/locales');
Object.keys(locales).forEach(function (lang) {
	Vue.locale(lang, locales[lang]);
});
// set validator locale
Vue.use(VeeValidate, {
	errorBagName: 'errorBag',
	locale: Vue.config.lang,
	dictionary: {
		bg: require('./lang/validator_bg')
	}
});

// register global components
Vue.component('c-avatar', require('./components/base/c-avatar.vue'));
Vue.component('c-uavatar', require('./components/base/c-uavatar.vue'));
Vue.component('c-categories', require('./components/base/category/c-categories.vue'));
Vue.component('f-input', require('./components/base/f-input.vue'));
Vue.component('f-select', require('./components/base/f-select.vue'));
Vue.component('f-category', require('./components/base/category/f-category.vue'));
Vue.component('f-textarea', require('./components/base/f-textarea.vue'));
Vue.component('f-radio', require('./components/base/f-radio.vue'));
Vue.component('f-image', require('./components/base/f-image.vue'));
Vue.component('f-pager', require('./components/base/f-pager.vue'));
Vue.component('f-modal', require('./components/base/f-modal.vue'));
Vue.component('f-family', require('./components/base/autocomplete/f-family.vue'));

var VueResource = require('vue-resource').default;
var VueRouter = require('vue-router').default;

Vue.use(VueResource);
Vue.use(VueRouter);

var routes = require('./routes');
var auth = require('./auth');

//

// Import Helpers for filters
var filters = require('./filters');
// Import Install and register helper items
Vue.filter('count', filters.count);
Vue.filter('domain', filters.domain);
Vue.filter('prettyDate', filters.prettyDate);
Vue.filter('prettyDateTime', filters.prettyDateTime);
Vue.filter('fromNowDateTime', filters.fromNowDateTime);
Vue.filter('pluralize', filters.pluralize);
Vue.filter('nl2br', filters.nl2br);

// Import Views - Top level
var AppView = require('./components/App.vue');

Vue.http.options.credentials = true;
Vue.http.interceptors.push((request, next) => {
	request.url = request.url.replace(/^backend:\//, Vue.config.backend);
	// console.log(headers)

	// continue to next interceptor without modifying the response
	next();
});

Vue.http.interceptors.push((request, next) => {
	next((response) => {
		if (!response.body) {
			return Promise.reject(new Error(response.statusText));
		}
		if (response.body.error !== undefined) {
			let errors = [];
			errors.push(response.body.error);
			for (let err in response.body.errors) {
				errors.push('Моля, попълнете правилно поле: ' + err);
			}
			return Promise.reject(new Error(errors.join('\n')));
		}
		return response;
	});
});

Vue.http.toastCatcher = function (exception) {
	if (exception instanceof Error) {
		exception = exception.text || exception.message || '';
	}
	exception = exception + '';

	let errors = exception.split('\n');

	if (errors.length === 0) {
		errors = ['Изпълнението на операцията е неуспешно. Моля, опитайте отново.'];
	}

	for (let error of errors) {
		window.app.$toasted.show(error).goAway(1500);
	}
};

Vue.http.putOrPostResource = function (url, body, options) {
	if (body.id === undefined) {
		return this.post(url, body, options);
	} else {
		url = url.replace(/\/$/, '') + '/' + encodeURIComponent(body.id);
		return this.put(url, body, options);
	}
};

// Routing logic
var router = new VueRouter({
	routes: routes,
	mode: 'history',
	base: '/network/',
	scrollBehavior: function (to, from, savedPosition) {
		return savedPosition || { x: 0, y: 0 };
	}
});

// Some middleware to help us ensure that the user is authenticated.
router.beforeEach((to, from, next) => {
	let nextPath = to.fullPath;
	let p = Promise.resolve();
	if (to.fullPath.match(/^\/login/)) {
		// pass
	} else if (to.fullPath.match(/^\/logout/)) {
		auth.logout(router.app);
		nextPath = '/login';
	} else {
		p = auth.getUser(router.app).then((user) => {
			if (user) {
				if (to.fullPath.match(/^\/moderate/) && (user.role === 'moderator' || user.role === 'admin')) {
					// pass
				} else if (user.familyUser === undefined) {
					if (!to.fullPath.match(/^\/registration/)) {
						nextPath = '/registration';
					}
				} else {
					if (to.fullPath.match(/^\/registration|^\/moderate/)) {
						nextPath = '/';
					} else {
						// pass
					}
				}
			} else {
				nextPath = '/login';
			}
		});
	}
	p.then(function () {
		if (to.fullPath !== nextPath) {
			next({
				path: nextPath,
				query: nextPath === '/login' && to.fullPath !== '/logout' ? { redirect: to.fullPath } : {}
			});
		} else {
			next();
		}
	});
});

Vue.mixin({
	data: function () {
		return {
			_validationData: {}
		};
	},
	computed: {
		$validationData: function () {
			return this.$data._validationData;
		},
		$config: function () {
			return Vue.config.common;
		},
		$user: function () {
			return this.$root.user;
		}
	}
});

// Start out app!
// eslint-disable-next-line no-new
window.app = new Vue({
	el: '#root',
	router: router,
	data: {
		user: undefined
	},
	render: (h) => h(AppView)
});



// WEBPACK FOOTER //
// ./src/main.js